// src/AppRoutes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";

// Páginas públicas
import BookPage from "./pages/BookPage";

// Panel Admin
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";

// Ruta protegida
function PrivateRoute({ children }) {
  const token = localStorage.getItem("adminToken");
  
  console.log("🔐 Verificando token:", token ? "✅ SÍ" : "❌ NO");

  if (!token) {
    console.log("❌ Sin token, redirigiendo a login");
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Página pública con layout */}
      <Route
        path="/"
        element={
          <Layout>
            <BookPage />
          </Layout>
        }
      />

      {/* Login admin (sin protección) */}
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Panel admin protegido */}
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      />

      {/* Cualquier ruta desconocida → inicio */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;